import { FormInput, Loader } from "@/components";
import { Button, Input } from "@/components/ui";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui";
import { FormProvider } from "react-hook-form";
import { CONFIRM_PASSWORD, NEW_PASSWORD, OTP } from "./consts";
import useResetPasswordWithOtp from "./useResetPasswordWithOtp";
import coverImg from "@/assets/loginCover.svg";

const ResetPasswordWithOtp = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    isPassword,
    isRestPasswordPending,
    isVerifyOtpPending,
    onEyeIconClick,
    Icon,
    onNextClick,
    showOtpSection,
    onEnterOtp,
    otpInputRef,
    otp,
  } = useResetPasswordWithOtp();
  const { errors } = form.formState;
 
  return (
    <div className="flex md:flex-row w-full h-[100vh]">
      <div className="hidden md:flex flex-col justify-center items-center w-1/2 bg-blue-900 text-white p-8 relative">
        <div className="absolute inset-0 bg-black bg-opacity-30"></div>
        <img
          src={coverImg}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="relative text-center z-10">
          <h1 className="text-[30px] lg:text-[54px] font-bold">
            Welcome to Communacam
          </h1>
        </div>
      </div>
      <div className="w-full md:w-1/2 bg-gray-100 flex flex-col justify-center items-center p-8">
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <Card className="w-full lg:w-[400px]">
              <CardHeader className="my-[20px]">
                <CardTitle className="text-center font-[500] text-[24px]">
                  Reset Password
                </CardTitle>
                <span className="text-[14px] text-g-400 text-center">
                  Update your password to ensure account security.
                </span>
              </CardHeader>
              <CardContent>
                <div className="grid grid-col-1 gap-5">
                  {showOtpSection ? (
                    <div key="otp">
                      <label className="text-[14px] font-[400]">
                        Enter OTP
                      </label>
                      <div className="grid grid-cols-6 gap-2 mt-2">
                        {otp?.map((val: string, index: number) => (
                          <Input
                            name={OTP}
                            placeholder=""
                            maxLength={1}
                            className="h-[50px] text-center text-[20px]"
                            onChange={(e) => onEnterOtp(e.target.value, index)}
                            value={val}
                            ref={(el: any) =>
                              ((otpInputRef.current[index] as any) = el)
                            }
                          />
                        ))}
                      </div>
                    </div>
                  ) : (
                    <>
                      <div key="new-password">
                        <label className="text-[14px] font-[400]">
                          New Password
                        </label>
                        <FormInput
                          name={NEW_PASSWORD}
                          control={form.control}
                          placeholder="Please enter"
                          error={errors[NEW_PASSWORD]?.message}
                          isRequired={requiredFields.includes(NEW_PASSWORD)}
                          type={isPassword["newPassword"] ? "password" : "text"}
                          endIcon={
                            <Icon
                              className="h-4 w-4"
                              onClick={onEyeIconClick("newPassword")}
                            />
                          }
                        />
                      </div>
                      <div key="confirm-password">
                        <label className="text-[14px] font-[400]">
                          Confirm Password
                        </label>
                        <FormInput
                          name={CONFIRM_PASSWORD}
                          control={form.control}
                          placeholder="Please enter"
                          error={errors[CONFIRM_PASSWORD]?.message}
                          isRequired={requiredFields.includes(CONFIRM_PASSWORD)}
                          type={isPassword["confirm"] ? "password" : "text"}
                          endIcon={
                            <Icon
                              className="h-4 w-4"
                              onClick={onEyeIconClick("confirm")}
                            />
                          }
                        />
                      </div>
                    </>
                  )}
                </div>
              </CardContent>
              <CardFooter>
                {showOtpSection ? (
                  <Button
                    type="button"
                    className="w-full"
                    onClick={onNextClick}
                    disabled={isVerifyOtpPending}
                  >
                    {isVerifyOtpPending ? <Loader variant="secondary" /> : ""}{" "}
                    Next
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    className="w-full"
                    disabled={isRestPasswordPending}
                  >
                    {isRestPasswordPending ? (
                      <Loader variant="secondary" />
                    ) : (
                      ""
                    )}{" "}
                    Reset Password
                  </Button>
                )}
              </CardFooter>
            </Card>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default ResetPasswordWithOtp;
